import { render, staticRenderFns } from "./ClubPayments.vue?vue&type=template&id=01368b96"
import script from "./ClubPayments.vue?vue&type=script&lang=js"
export * from "./ClubPayments.vue?vue&type=script&lang=js"
import style0 from "./ClubPayments.vue?vue&type=style&index=0&id=01368b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports